import { StyledButton } from './BaseButton.styles';
import { BaseButtonProps } from './BaseButton.interface';

export const BaseButton = ({ label, ...props }: BaseButtonProps) => {
  return <StyledButton {...props}>{label}</StyledButton>;
};
